import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import FasteezyReportCard from './components/FasteezyReportIndex.jsx';

const FasteezyReport = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Fasteezy Report</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / Fasteezy Report</h3>
        </Col>
      </Row>
      <Row>
        <FasteezyReportCard />
      </Row>
    </Container>
)}

export default FasteezyReport;
